document.addEventListener("DOMContentLoaded", function (event) {
  // By listening for the 'beforeinstallprompt' event and preventing its default behavior,
  // we stop the browser from automatically showing the "Add to Home Screen" banner.
  // The app will still be installable via the browser's menu.
  window.addEventListener('beforeinstallprompt', (e) => {
    // Prevent the mini-infobar from appearing on mobile
    e.preventDefault();
    // Optionally, you could save the event to trigger it later with your own button.
    // window.deferredPrompt = e;
  });

  if ("serviceWorker" in navigator) {
    window.addEventListener("load", function () {
      if (import.meta.env.PROD) {
        navigator.serviceWorker.register("/sw.js")
          .then(registration => {
            console.log("Service Worker Successfully registered");
            console.log(navigator.serviceWorker.ready);
          })
          .catch(err => {
            console.error('An error occurred while registering the service worker.');
            console.error(err);
          });

      }
      else {
        navigator.serviceWorker.register("/sw-dev.js")
          .then(registration => {
            console.log("Service Worker DEV Successfully registered");
            console.log(navigator.serviceWorker.ready);
          })
          .catch(err => {
            console.error('An error occurred while registering the service worker DEV.');
            console.error(err);
          });

      }
    });

  }

});